import { render } from "./HtmlContent.vue?vue&type=template&id=0d42193a"
import script from "./HtmlContent.vue?vue&type=script&lang=js"
export * from "./HtmlContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__